import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * RedirectHandler component to handle URL redirects and fix common routing issues
 * This helps resolve Google Search Console redirect errors
 */
const RedirectHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const currentPath = location.pathname;
    const currentSearch = location.search;
    
    // Handle trailing slash redirects
    if (currentPath.endsWith('/') && currentPath !== '/') {
      const newPath = currentPath.slice(0, -1);
      navigate(newPath + currentSearch, { replace: true });
      return;
    }

    // Only handle essential redirects to prevent SEO issues
    // Most redirects are now handled by .htaccess for better SEO performance

    // Handle query parameter cleanup for SEO
    if (currentSearch) {
      const urlParams = new URLSearchParams(currentSearch);
      
      // Remove tracking parameters that might cause duplicate content
      const trackingParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'ref', 'source'];
      let hasTrackingParams = false;
      
      trackingParams.forEach(param => {
        if (urlParams.has(param)) {
          urlParams.delete(param);
          hasTrackingParams = true;
        }
      });
      
      // If we removed tracking parameters, redirect to clean URL
      if (hasTrackingParams) {
        const cleanSearch = urlParams.toString();
        const cleanUrl = currentPath + (cleanSearch ? `?${cleanSearch}` : '');
        navigate(cleanUrl, { replace: true });
      }
    }
  }, [location, navigate]);

  return null; // This component doesn't render anything
};

export default RedirectHandler;